// hooks/useRightPanelProps.js
import { pluralize } from '../../../utility/helperFunctions'
import { DUAL_PANEL_SELECTABLE_TYPES } from '../../../constants/dual-panel-selector-constants'
import classes from './PostAnnouncementModal.module.scss'
import { ReactComponent as FlagIcon } from '../../../assets/images/common/icons/Flag.svg'

export const useRightPanelProps = (selectedPrograms, selectedSeries, selectedStudents, selectedCoaches) => {
  const totalStudents =
    selectedPrograms?.reduce((acc, program) => acc + program?.students?.length, 0) +
    selectedSeries?.reduce((acc, series) => acc + series?.students?.length, 0) +
    selectedStudents?.length

  const rightPanelText =
    `Summary (${selectedPrograms?.length + pluralize(' Program', selectedPrograms?.length)},
     ${selectedSeries?.length + pluralize(' Serie', selectedSeries?.length)},
     ${totalStudents + pluralize(' Student', totalStudents)},
     ${selectedCoaches?.length + pluralize(' Coach', selectedCoaches?.length, ' Coaches')
})`

  const SummaryPlaceholder = () => (
    <div className={classes.placeholder}>
      <FlagIcon className={classes.icon} />
      <h2 className={classes.title}>No Programs / Events Added</h2>
      <p className={classes.description}>Add your events or programs to continue</p>
    </div>
  )

  return {
    selectedItems: [...selectedPrograms, ...selectedSeries, ...selectedStudents, ...selectedCoaches],
    selectedItemType: DUAL_PANEL_SELECTABLE_TYPES.students,
    summaryTitle: rightPanelText,
    summaryPlaceholder: <SummaryPlaceholder />,
  }
}
